/** @jsxImportSource @emotion/react */

import HelmetCustom from "components/common/HelmetCustom";
import HeaderMobile from "components/mobile/HeaderMobile";

import FromHistoryMobile from "./FormHistory";
import { BettingHistoryPageStyle } from "./style.index";
import TableHistoryMobile from "./TableHistory";

const BettingHistoryPage = () => {
  return (
    <div css={BettingHistoryPageStyle.wrapper}>
      <HelmetCustom title=" Betting History" />
      <HeaderMobile title="Chi tiết đặt cược" />
      <div css={BettingHistoryPageStyle.mainContent}>
        <FromHistoryMobile />
        <TableHistoryMobile />
      </div>
    </div>
  );
};

export default BettingHistoryPage;
